import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { registerField, change } from 'redux-form';

function AttendingInput({ input, meta: { touched, error } }) {
  const { onChange, value } = input;
  const isAttending = value === 'ATTENDING';
  const isDeclined = value === 'DECLINED';

  return (
    <div className={`form-group attending${touched && error ? ' has-error' : ''}`}>
      <div className="row">
        <div className="col-xs-6 col-sm-6 col-md-6">
          <div
            className={`btn ${isAttending ? ' btn-active' : ''}`}
            onClick={() => onChange('ATTENDING')}
          >
            Will Attend
          </div>
        </div>
        <div className="col-xs-6 col-sm-6 col-md-6">
          <div
            className={`btn ${isDeclined ? ' btn-active' : ''}`}
            onClick={() => onChange('DECLINED')}
          >
            Will Not Attend
          </div>
        </div>
      </div>
      {touched && error && (
        <div>
          <span className="help-block danger-text">{error}</span>
        </div>
      )}
    </div>
  );
}

AttendingInput.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
  }),
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

const mapDispatchToProps = dispatch => ({
  onRegisterField: (name, type) => dispatch(registerField('GuestRsvpForm', name, type)),
  onChangeField: (name, value) => dispatch(change('GuestRsvpForm', name, value)),
});

export default connect(null, mapDispatchToProps)(AttendingInput);



// WEBPACK FOOTER //
// ./src/components/PublicWebsite/pages/rsvp/RsvpForm/GuestFields/AttendingInput.jsx